import * as Yup from 'yup';

export const MAXIMUM_LIMIT_MESSAGE = 'Maximum limit exceeded.';

export default function getStringSchema(maxLimit: number, customMessage: string = 'Name') {
  return Yup.string()
    .max(maxLimit, MAXIMUM_LIMIT_MESSAGE)
    .required(`${customMessage} is required.`);
}

export function getMaxStringSchema() {
  return Yup.string().max(15000, MAXIMUM_LIMIT_MESSAGE).nullable();
}
